import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";

const Alert = (props) => {
  const {
    onDelete,
    onClose,
    content,
    contentTitle,
    yesButtonName,
    noButtonName,
    type,
    cancelButtonClassName,
    confirmButtonClassName,
    saveAndClose,
    onSaveAndClose,
  } = props;
  return (
    <>
      <Modal
        show={true}
        onHide={() => onClose()}
        backdrop="static"
        dialogClassName="sh_modalConfirm"
        centered
        keyboard={false}
        className="modal-fade"
      >
        <Modal.Header
          closeButton
          className="border-bottom"
        >
          <Modal.Title as="h6" className="fw-semibold text-center">
            {type === "delete"
              ? "Delete"
              : type === "warning" && !props.custonTitle
              ? "Unsaved Changes"
              : type === "warning" && props.custonTitle
              ? props.custonTitle 
              : "Alert"}
          </Modal.Title>
        </Modal.Header>

        {/* body and content */}
        <Modal.Body>
          <div className=" flex-column">
            {/* render icon based on type */}
            {type === "delete" && (
              <div className="mb-2">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 56 56"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    width="80"
                    height="80"
                    rx="40"
                    fill="#fef1f2"
                    d="M28 0H28A28 28 0 0 1 56 28V28A28 28 0 0 1 28 56H28A28 28 0 0 1 0 28V28A28 28 0 0 1 28 0z"
                  />
                  <path
                    d="M28.003 29.459q0.62 0 1.04 -0.42 0.419 -0.419 0.419 -1.039v-5.869q0 -0.619 -0.419 -1.021 -0.42 -0.401 -1.04 -0.401t-1.038 0.419q-0.42 0.42 -0.42 1.04v5.869q0 0.619 0.42 1.021 0.418 0.401 1.038 0.401m0 5.833q0.62 0 1.04 -0.42 0.419 -0.419 0.419 -1.038t-0.419 -1.04q-0.42 -0.419 -1.04 -0.419t-1.038 0.419q-0.42 0.42 -0.42 1.04 0 0.619 0.42 1.038 0.418 0.42 1.038 0.42m0 7.292q-3.026 0 -5.688 -1.149 -2.661 -1.148 -4.63 -3.116 -1.969 -1.968 -3.116 -4.63 -1.149 -2.661 -1.149 -5.688t1.149 -5.688q1.148 -2.661 3.116 -4.63 1.969 -1.969 4.63 -3.118 2.661 -1.148 5.688 -1.148t5.688 1.148q2.661 1.149 4.63 3.118t3.116 4.63q1.149 2.661 1.149 5.688t-1.149 5.688q-1.148 2.662 -3.116 4.63t-4.63 3.116q-2.661 1.149 -5.688 1.149m0 -2.917q4.848 0 8.259 -3.408 3.408 -3.409 3.408 -8.259 0 -4.848 -3.408 -8.259 -3.409 -3.408 -8.259 -3.408 -4.849 0 -8.257 3.408Q16.338 23.152 16.338 28t3.409 8.259q3.408 3.408 8.257 3.408"
                    fill="#e02d3c"
                  />
                </svg>
              </div>
            )}
            {type === "warning" && (
              <div className="mb-2">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="80" height="80" rx="40" fill="#FFF8EB" />
                  <path
                    d="M39.9948 42.3332V34.5415"
                    stroke="#E4B200"
                    stroke-width="3.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M39.9927 48.5941C39.7052 48.5941 39.4719 48.8274 39.474 49.1149C39.474 49.4024 39.7073 49.6357 39.9948 49.6357C40.2823 49.6357 40.5156 49.4024 40.5156 49.1149C40.5156 48.8274 40.2823 48.5941 39.9927 48.5941"
                    stroke="#E4B200"
                    stroke-width="3.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M44.2318 23.6229L60.1881 51.5479C62.0422 54.7937 59.6985 58.8333 55.961 58.8333H24.0485C20.3089 58.8333 17.9651 54.7937 19.8214 51.5479L35.7776 23.6229C37.6464 20.35 42.363 20.35 44.2318 23.6229Z"
                    stroke="#E4B200"
                    stroke-width="3.75"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            )}
            {/* title */}
            <h6 className="modal-title w-100">{contentTitle}</h6>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer justify-content-center">
          {saveAndClose ? (
            <>
              <button
                type="button"
                className="btn btn-outline-secondary sh_btnlight"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-warning sh_btnyellow"
                onClick={onDelete}
              >
                Confirm
              </button>
              <button
                type="button"
                className="btn btn-primary "
                onClick={onSaveAndClose}
              >
                Save & Close
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-outline-secondary sh_btnlight"
                onClick={onClose}
              >
                {noButtonName}
              </button>
              {/* render yes button based on type */}
              {type === "delete" && (
                <button
                  type="button"
                  className="btn btn-danger sh_btndangernew"
                  onClick={onDelete}
                >
                  {yesButtonName}
                </button>
              )}
              {type === "warning" && (
                <button
                  type="button"
                  className={
                    confirmButtonClassName
                      ? confirmButtonClassName
                      : "btn btn-warning"
                  }
                  onClick={onDelete}
                >
                  {yesButtonName}
                </button>
              )}
            </>
          )}
          {/* */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

Alert.defaultProps = {
  contentTitle: "Are you sure you want to delete this Item?",
  content: "Do you really want to delete this record?",
  type: "delete",
  noButtonName: "Cancel",
  yesButtonName: "Confirm",
  confirmButtonClassName: "",
  cancelButtonClassName: "",
  onClose: () => {},
  onDelete: () => {},
  saveAndClose: false,
  onSaveAndClose: () => {},
};

Alert.propTypes = {
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
};

export default Alert;
